import { useState } from 'react';
import { apiClient, SubmitFormData, SubmitResponse } from '../service/apiService'

interface UseFormSubmissionReturn {
  isSubmitting: boolean;
  submitError: string | null;
  submitSuccess: boolean;
  submitResponse: SubmitResponse | null;
  submitForm: (formData: SubmitFormData) => Promise<void>;
  resetSubmission: () => void;
}

export function useFormSubmission(): UseFormSubmissionReturn {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState<string | null>(null);
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [submitResponse, setSubmitResponse] = useState<SubmitResponse | null>(null);

  const submitForm = async (formData: SubmitFormData) => {
    setIsSubmitting(true);
    setSubmitError(null);
    setSubmitSuccess(false);
    setSubmitResponse(null);

    try {
      console.log('Submitting form data:', {
        ...formData,
        // Don't log sensitive data in production
        code: formData.code ? '[REDACTED]' : undefined,
      });

      const response = await apiClient.submitForm(formData);
      
      setSubmitResponse(response);
      setSubmitSuccess(true);
      
      console.log('Form submitted successfully:', response);
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : 'Submission failed';
      setSubmitError(errorMessage);
      console.error('Form submission error:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const resetSubmission = () => {
    setIsSubmitting(false);
    setSubmitError(null);
    setSubmitSuccess(false);
    setSubmitResponse(null);
  };

  return {
    isSubmitting,
    submitError,
    submitSuccess,
    submitResponse,
    submitForm,
    resetSubmission,
  };
}
